import { Link } from "react-scroll";
import { useState } from "react";
import assalariado from "../assets/images/assalariado.png"; // Fallback
import fundo1 from "../assets/images/fundo1.svg";
const verdurasVideo = require("../assets/videos/verduras.mp4");

const Sobre = () => {
	const [videoLoaded, setVideoLoaded] = useState(false);
	const [videoError, setVideoError] = useState(false);

	const handleVideoLoad = () => {
		setVideoLoaded(true);
	};

	const handleVideoError = () => {
		setVideoError(true);
		console.log('Erro ao carregar vídeo, usando imagem fallback');
	};

	return (
		<div
			id="sobre"
			className="w-full flex font-public gap-[8rem] pt-20 md:gap-[3rem] md:pt-8 md:flex-col xl:gap-[3rem] xl:pt-8 xl:flex-col relative"
		>
			<div className="flex flex-col justify-between w-[50%] md:w-full md:gap-6 xl:w-full xl:gap-6 relative z-[2]">
				<div className="flex flex-col gap-8 md:gap-4 md:text-center xl:gap-4 xl:text-center">
					<div className="flex flex-col text-[2.5rem] font-bold items-start md:items-center md:text-[2rem] xl:items-center xl:text-[3rem]">
						<h2>
							Entrega de <span className="text-verde-escuro2">legumes</span>{" "}
							<br />
							Direto da fazenda para sua distribuidora
						</h2>
					</div>
					<div className="flex flex-col text-cinza font-bold gap-3 items-start md:items-center md:text-[1rem] xl:items-center xl:text-[1.5rem]">
						<p>
							Ofereça aos seus clientes a qualidade e o frescor que eles merecem com nossos legumes colhidos diretamente da fazenda. Garantimos produtos frescos e selecionados, prontos para atender às demandas do seu negócio, sempre com um rigoroso controle de qualidade.
						</p>
						<p>
							Nossa cadeia de produção é otimizada para assegurar que os legumes cheguem ao seu estabelecimento no ponto ideal de consumo, preservando o sabor, a textura e os nutrientes. Com uma logística eficiente e uma parceria sólida com produtores locais, garantimos entregas pontuais e produtos da mais alta qualidade.
						</p>
					</div>
				</div>
				<div className="flex justify-start md:justify-center xl:justify-center">
					<Link
						to="produtos"
						spy={true}
						smooth={true}
						offset={-100}
						duration={500}
						activeClass="text-[#13613D] border-b-2 border-b-[#13613D]"
					>
						<button className="bg-verde-claro font-bold text-[1.25rem] text-white px-6 py-[0.65rem] rounded-[3.2rem] hover:bg-verde-escuro3 transition xl:text-[2rem] sm:text-[1.2rem]">
							Veja nossos produtos
						</button>
					</Link>
				</div>
			</div>
			
			{/* Container do vídeo/imagem */}
			<div className="w-[50%] md:w-full xl:w-full relative">
				{/* Vídeo de verduras - mesmas dimensões da imagem */}
				{!videoError ? (
					<video
						className={`relative z-[2] w-full h-auto transition-opacity duration-500 ${
							videoLoaded ? 'opacity-100' : 'opacity-0'
						}`}
						autoPlay
						muted
						loop
						playsInline
						preload="metadata"
						onCanPlay={handleVideoLoad}
						onLoadedData={handleVideoLoad}
						onError={handleVideoError}
						style={{ aspectRatio: '1791/1413' }}
					>
						<source src={verdurasVideo} type="video/mp4" />
					</video>
				) : (
					/* Imagem de fallback caso haja erro no vídeo */
					<img 
						src={assalariado} 
						alt="Produção de verduras" 
						className="relative z-[2]"
					/>
				)}
				
				{/* Imagem placeholder durante loading */}
				{!videoLoaded && !videoError && (
					<img 
						src={assalariado} 
						alt="Produção de verduras" 
						className="relative z-[2]"
					/>
				)}
				
				{/* Loading indicator */}
				{!videoLoaded && !videoError && (
					<div className="absolute inset-0 flex items-center justify-center z-[3] bg-black/10 rounded">
						<div className="w-8 h-8 border-2 border-verde-claro/30 border-t-verde-claro rounded-full animate-spin"></div>
					</div>
				)}
			</div>
			
			<img
				src={fundo1}
				alt="fundo1"
				className="absolute sm:-top-[60px] sm:-right-52 lg:-right-[650px] -top-36 -right-[720px] z-[1] md:-right-[500px]"
			/>
		</div>
	);
};

export default Sobre;